
document.addEventListener('DOMContentLoaded', function() {
  function getTimezoneMidnight() {
    const timezone = 'America/New_York';
    const now = new Date();
    const localTime = new Date(now.toLocaleString('en-US', { timeZone: timezone }));
    const midnight = new Date(localTime);
    midnight.setHours(24, 0, 0, 0);
    return midnight;
  }

  function calculateTimeLeft() {
    const timezone = 'America/New_York';
    const now = new Date();
    const localTime = new Date(now.toLocaleString('en-US', { timeZone: timezone }));
    
    
    // Otherwise use midnight in selected timezone
    const midnight = getTimezoneMidnight();
    let diff = midnight - localTime;
    
    // If we're past midnight, get next midnight
    if (diff < 0) {
      midnight.setDate(midnight.getDate() + 1);
      diff = midnight - localTime;
    }
    

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    return { days, hours, minutes, seconds };
  }

  function updateDisplay() {
    const timeLeft = calculateTimeLeft();
    
    
    document.querySelector('.ewc-horas').textContent = timeLeft.hours.toString().padStart(2, '0');
    document.querySelector('.ewc-min').textContent = timeLeft.minutes.toString().padStart(2, '0');
    document.querySelector('.ewc-seg').textContent = timeLeft.seconds.toString().padStart(2, '0');
  }

  // Update immediately and then every second
  updateDisplay();
  const timer = setInterval(updateDisplay, 1000);

  // Cleanup on section unload to avoid memory leaks
  document.addEventListener('shopify:section:unload', function() {
    clearInterval(timer);
  });
});
